var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-note bg-white"
  }, [_c('div', {
    staticClass: "success"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/payicon.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "message blue"
  }, [_vm._v("支付成功")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('mt-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.toSign
    }
  }, [_vm._v("去签订")])], 1)])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tip"
  }, [_vm._v("系统检测到您已完成《投资者风险承受能力问卷》的填写. 加油, 只需签订"), _c('div', {
    staticClass: "blue"
  }, [_vm._v("电子合同")]), _vm._v("就可以完成订单")])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@13.0.2@vue-loader/lib/template-compiler?{"id":"data-v-168894d2","hasScoped":true}!./~/_vue-loader@13.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/customer/OrderContract.vue
// module id = 232
// module chunks = 0